import React, { Component } from "react"
export default  class UploadModal extends Component {
  constructor(props) {
    super(props)

    this.modal = null

    this.setModalRef = element => { this.modal = element }
  }

  componentDidMount() {
    this.open()
  }

  componentWillUnmount() {
    this.close()
  }

  close() {
    $(this.modal).modal('hide')
  }

  open() {
    $(this.modal).modal('show')
  }

  renderUploadModal(){
    return (
      <div className="questionnaire-modal-container">
      
        <p className="center-this-tag">Questionnaire(s) have been sent.</p>

      <div className="questionnaire-modal-center">
        <button className="questionnaire-pricing-btn-submit" onClick={() => this.props.closeUploadModal()}>OK</button>
      </div>
    </div>
    ) 
  }


  render(){
    return (
      <div className="modal" ref={this.setModalRef}>
        <div className="modal-dialog modal-md questionnaire-modal-dialog">
          <div className="modal-body">
            <h3 className="text-center bopa-text questionnaire-form-header">Success!</h3>
                {this.renderUploadModal()}
          </div>
        </div>
      </div>
    )
  }
};
